var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMaintenanceIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98085 28.3659C7.27653 26.8997 3.24202 27.4359 3.24218 29.9744V33.1951H9.72652V29.9744C9.72652 29.2946 9.43723 28.7585 8.98085 28.3659Z",
    fill: "#987C39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0385 28.3659C60.7392 26.8997 64.765 27.4359 64.7648 29.9744V33.1951H58.2945V29.9744C58.2945 29.2946 58.5832 28.7585 59.0385 28.3659Z",
    fill: "#987C39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0L0 5.60465H32.4954H35.5748H68V0H0Z",
    fill: "#987C39"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62109 33.1951V62.3953H66.3824V33.1951H64.7648H58.2945H9.72652H3.24218H1.62109Z",
    fill: "#E6D262"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.62109 62.3953L1.69477 64.6977H66.3089L66.3824 62.3953H1.62109Z",
    fill: "#987C39"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.69477 64.6977L1.62109 67H66.3824L66.3089 64.6977H1.69477Z",
    fill: "#DCB902"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.1896 33.2326C6.1896 33.2326 6.1896 56.5994 6.1896 58.1572C6.1896 59.715 8.41786 59.715 8.41786 58.1572C8.41786 56.5994 8.41786 33.2326 8.41786 33.2326H6.1896Z",
    fill: "#DCB902"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5591 33.2326C19.5591 33.2326 19.5591 56.5994 19.5591 58.1572C19.5591 59.715 21.7874 59.715 21.7874 58.1572C21.7874 56.5994 21.7874 33.2326 21.7874 33.2326H19.5591Z",
    fill: "#DCB902"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9287 33.2326C32.9287 33.2326 32.9287 56.5994 32.9287 58.1572C32.9287 59.715 35.1569 59.715 35.1569 58.1572C35.1569 56.5994 35.1569 33.2326 35.1569 33.2326H32.9287Z",
    fill: "#DCB902"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M46.2982 33.2326C46.2982 33.2326 46.2982 56.5994 46.2982 58.1572C46.2982 59.715 48.5265 59.715 48.5265 58.1572C48.5265 56.5994 48.5265 33.2326 48.5265 33.2326H46.2982Z",
    fill: "#DCB902"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M52.983 33.2326C52.983 33.2326 52.983 56.5994 52.983 58.1572C52.983 59.715 55.2112 59.715 55.2112 58.1572C55.2112 56.5994 55.2112 33.2326 55.2112 33.2326H52.983Z",
    fill: "#DCB902"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.6678 33.2326C59.6678 33.2326 59.6678 56.5994 59.6678 58.1572C59.6678 59.715 61.896 59.715 61.896 58.1572C61.896 56.5994 61.896 33.2326 61.896 33.2326H59.6678Z",
    fill: "#DCB902"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2439 33.2326C26.2439 33.2326 26.2439 56.5994 26.2439 58.1572C26.2439 59.715 28.4722 59.715 28.4722 58.1572C28.4722 56.5994 28.4722 33.2326 28.4722 33.2326H26.2439Z",
    fill: "#DCB902"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6134 33.2326C39.6134 33.2326 39.6134 56.5994 39.6134 58.1572C39.6134 59.715 41.8417 59.715 41.8417 58.1572C41.8417 56.5994 41.8417 33.2326 41.8417 33.2326H39.6134Z",
    fill: "#DCB902"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8744 33.2326C12.8744 33.2326 12.8744 56.5994 12.8744 58.1572C12.8744 59.715 15.1026 59.715 15.1026 58.1572C15.1026 56.5994 15.1026 33.2326 15.1026 33.2326H12.8744Z",
    fill: "#DCB902"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5748 5.60465V13H32.4954V5.60465H35.5748Z",
    fill: "#141414"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72652 29.9744C9.72652 29.2946 9.43723 28.7585 8.98085 28.3659L29.1796 17.9024L30 19.5626L9.72652 29.9744Z",
    fill: "#141414"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2945 29.9744C58.2945 29.2946 58.5832 28.7585 59.0385 28.3659L38.8835 17.9024L38 19.5293L58.2945 29.9744Z",
    fill: "#141414"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8835 17.9024L35.5748 14.061V13H32.4954V14.0465L29.1796 17.9024L30 19.5626L33 19.5H35L38 19.5293L38.8835 17.9024Z",
    fill: "#987C39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceIcon1);
export default __webpack_public_path__ + "static/media/maintenance-icon-1.d5fbe038cea5237d633240dac511927a.svg";
export { ForwardRef as ReactComponent };